import { streemLogger } from '../util/streem_logger';
export class DownlinkObserver {
    constructor() {
        this.logger = streemLogger.extend('sdk-chime-video:DownlinkObserver');
    }
    tileWillBePausedByDownlinkPolicy(tileId) {
        this.logger.info(`Tile ${tileId} paused by downlink policy`);
    }
    tileWillBeUnpausedByDownlinkPolicy(tileId) {
        this.logger.info(`Tile ${tileId} unpaused by downlink policy`);
    }
}
//# sourceMappingURL=video_downlink_observer.js.map